import * as React from 'react';
const SvgNoReq = (props) => (
  <svg
    width={149}
    height={134}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M71.6219 103.3C99.6219 103.3 122.322 80.6002 122.322 52.5002C122.322 24.4002 99.5219 1.7002 71.6219 1.7002C43.6219 1.7002 20.9219 24.4002 20.9219 52.5002C20.9219 80.6002 43.6219 103.3 71.6219 103.3Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_2329_16252)">
      <path
        d="M86.3204 25.5L101.62 80.5C102.12 82.4 101.02 84.3 99.1204 84.8L45.2204 99.1003C43.3204 99.6003 41.4204 98.5003 40.9204 96.6L22.1204 25.6C21.6204 23.7 22.7204 21.8 24.6204 21.3L63.6204 11L86.3204 25.5Z"
        fill="url(#paint0_linear_2329_16252)"
      />
    </g>
    <path
      d="M85.5207 60.2999L56.4207 67.9999L53.2207 68.7999L43.5207 71.3999C43.1207 71.4999 42.8207 71.9999 43.0207 72.4999C43.1207 72.9999 43.6207 73.2999 44.0207 73.1999L53.7207 70.5999L56.9207 69.7999L86.0207 62.0999C86.4207 61.9999 86.7207 61.4999 86.5207 60.9999C86.4207 60.4999 85.9207 60.1999 85.5207 60.2999Z"
      fill="#D5DDEA"
    />
    <path
      d="M83.6215 53.4999L72.8215 56.2999L69.1215 57.2999L41.8215 64.5999C41.4215 64.6999 41.1215 65.1999 41.3215 65.6999C41.4215 66.1999 41.9215 66.4999 42.3215 66.3999L69.7215 59.0999L73.4215 58.0999L84.2215 55.2999C84.6215 55.1999 84.9215 54.6999 84.7215 54.1999C84.5215 53.7999 84.0215 53.3999 83.6215 53.4999Z"
      fill="#D5DDEA"
    />
    <path
      d="M82.0191 46.5999L79.2191 47.2999L76.4191 47.9999L39.9191 57.6999C39.5191 57.7999 39.2191 58.2999 39.4191 58.7999C39.5191 59.2999 40.0191 59.5999 40.4191 59.4999L76.9191 49.7999L80.0191 48.9999L82.5191 48.2999C82.9191 48.1999 83.2191 47.6999 83.0191 47.1999C82.9191 46.7999 82.5191 46.4999 82.0191 46.5999Z"
      fill="#D5DDEA"
    />
    <path
      d="M65.1192 82.0001L63.1192 82.5001C62.7192 82.6001 62.2192 82.3001 62.1192 81.8001C62.0192 81.3001 62.2192 80.8001 62.6192 80.7001L64.6192 80.2001C65.0192 80.1001 65.5192 80.4001 65.6192 80.9001C65.7192 81.5001 65.5192 81.9001 65.1192 82.0001Z"
      fill="#CED7E2"
    />
    <path
      d="M59.0216 83.5999L47.5216 86.5999C47.1216 86.6999 46.6216 86.3999 46.5216 85.8999C46.4216 85.3999 46.6216 84.8999 47.0216 84.7999L58.5216 81.7999C58.9216 81.6999 59.4216 81.9999 59.5216 82.4999C59.7216 82.9999 59.5216 83.4999 59.0216 83.5999Z"
      fill="#D5DDEA"
    />
    <path
      d="M80.6199 39.7001L71.5199 42.1001L69.3199 42.7001L38.2199 50.9001C37.8199 51.0001 37.5199 51.5001 37.7199 52.0001C37.8199 52.5001 38.3199 52.8001 38.7199 52.7001L69.7199 44.6001L71.9199 44.0001L80.9199 41.6001C81.4199 41.5001 81.6199 41.0001 81.5199 40.4001C81.5199 40.0001 81.0199 39.6001 80.6199 39.7001Z"
      fill="#D5DDEA"
    />
    <path
      d="M59.1192 24.5999L33.3192 31.3999C32.7192 31.5999 32.1192 31.1999 31.9192 30.5999C31.7192 29.9999 32.1192 29.3999 32.7192 29.1999L58.5192 22.3999C59.1192 22.1999 59.7192 22.5999 59.9192 23.1999C60.1192 23.7999 59.7192 24.3999 59.1192 24.5999Z"
      fill="#D5DDEA"
    />
    <path
      d="M44.9223 35.0001L35.0223 37.6001C34.4223 37.8001 33.8223 37.4001 33.6223 36.8001C33.4223 36.2001 33.8223 35.6001 34.4223 35.4001L44.2223 32.8001C44.8223 32.6001 45.4223 33.0001 45.6223 33.6001C45.8223 34.2001 45.4223 34.8001 44.9223 35.0001Z"
      fill="#D5DDEA"
    />
    <path
      d="M63.6211 11L67.6212 26.2C68.2212 28.3 70.5212 29.6 72.6212 29L86.3212 25.5"
      fill="#D5DDEA"
    />
    <g filter="url(#filter1_d_2329_16252)">
      <path
        d="M126.722 41.0001L117.522 97.4001C117.222 99.3003 115.322 100.6 113.422 100.2L58.6227 90.6001C56.7227 90.3001 55.4227 88.4001 55.7227 86.5001L68.4227 14.2001C68.7227 12.3001 70.6227 11.0001 72.5227 11.4001L112.322 18.4001L126.722 41.0001Z"
        fill="url(#paint1_linear_2329_16252)"
      />
    </g>
    <path
      d="M111.42 72.3001L81.8202 67.1001L78.6202 66.5001L68.7202 64.8001C68.3202 64.7001 67.8202 65.1001 67.8202 65.6001C67.7202 66.1001 68.0202 66.6001 68.4202 66.7001L78.3202 68.4001L81.5202 69.0001L111.12 74.2001C111.52 74.3001 112.02 73.9001 112.02 73.4001C112.12 72.9001 111.92 72.4001 111.42 72.3001Z"
      fill="#CED7E2"
    />
    <path
      d="M112.621 65.4002L101.621 63.5002L97.9209 62.8002L70.0209 57.9002C69.6209 57.8002 69.1209 58.2002 69.1209 58.7002C69.0209 59.2002 69.3209 59.7002 69.7209 59.8002L97.6209 64.7002L101.321 65.4002L112.321 67.3002C112.721 67.4002 113.221 67.0002 113.221 66.5002C113.321 66.0002 113.021 65.5002 112.621 65.4002Z"
      fill="#CED7E2"
    />
    <path
      d="M114.021 58.4002L111.121 57.9002L108.221 57.4002L71.0209 50.9002C70.6209 50.8002 70.1209 51.2002 70.1209 51.7002C70.0209 52.2002 70.3209 52.7002 70.7209 52.8002L107.921 59.3002L111.121 59.9002L113.621 60.3002C114.021 60.4002 114.521 60.0002 114.521 59.5002C114.721 59.0002 114.521 58.5002 114.021 58.4002Z"
      fill="#D5DDEA"
    />
    <path
      d="M83.8225 83.5001L81.8225 83.2001C81.4225 83.1001 81.1225 82.6001 81.2225 82.1001C81.3225 81.6001 81.7225 81.2001 82.1225 81.3001L84.1225 81.6001C84.5225 81.7001 84.8225 82.2001 84.7225 82.7001C84.6225 83.3001 84.2225 83.5001 83.8225 83.5001Z"
      fill="#CED7E2"
    />
    <path
      d="M77.7218 82.4L66.0217 80.4C65.6217 80.3 65.3217 79.8 65.4217 79.3C65.5217 78.8 65.9218 78.4 66.3218 78.5L78.0217 80.5C78.4217 80.6 78.7218 81.1 78.6218 81.6C78.5218 82.2 78.1218 82.5 77.7218 82.4Z"
      fill="#E3EAF2"
    />
    <path
      d="M115.622 51.6L106.322 50L104.022 49.6L72.3218 44C71.9218 43.9 71.4217 44.3 71.4217 44.8C71.3217 45.3 71.6217 45.8 72.0217 45.9L103.722 51.5L106.022 51.9L115.222 53.5C115.722 53.6 116.122 53.2 116.222 52.7C116.322 52.2 116.022 51.7 115.622 51.6Z"
      fill="#D5DDEA"
    />
    <path
      d="M102.52 28.9L76.22 24.3C75.62 24.2 75.22 23.6 75.32 23C75.42 22.4 76.02 22 76.62 22.1L102.92 26.7C103.52 26.8 103.92 27.4 103.82 28C103.72 28.5 103.12 29 102.52 28.9Z"
      fill="#D5DDEA"
    />
    <path
      d="M85.2223 32.3002L75.1223 30.5002C74.5223 30.4002 74.1223 29.8002 74.2223 29.2002C74.3223 28.6002 74.9223 28.2002 75.5223 28.3002L85.5223 30.1002C86.1223 30.2002 86.5223 30.8002 86.4223 31.4002C86.3223 32.0002 85.7223 32.4002 85.2223 32.3002Z"
      fill="#D5DDEA"
    />
    <path
      d="M112.222 18.4001L109.522 33.9001C109.122 36.1001 110.722 38.2001 112.922 38.6001L126.722 41.0001"
      fill="#D5DDEA"
    />
    <path
      d="M89.0187 92.1C101.334 92.1 111.318 82.1159 111.318 69.8C111.318 57.484 101.334 47.5 89.0187 47.5C76.7028 47.5 66.7188 57.484 66.7188 69.8C66.7188 82.1159 76.7028 92.1 89.0187 92.1Z"
      fill="white"
    />
    <path
      d="M86.9187 73.4001C86.8187 73.0001 86.8187 72.6001 86.8187 72.1001C86.8187 70.4001 87.5187 68.9001 89.3187 67.6001L90.8187 66.5001C91.7187 65.8001 92.1187 65.0001 92.1187 64.0001C92.1187 62.6001 91.1187 61.2001 89.0187 61.2001C86.8187 61.2001 85.8187 63.0001 85.8187 64.7001C85.8187 65.1001 85.8187 65.4001 85.9187 65.7001L81.9187 65.6001C81.8187 65.2001 81.7188 64.7001 81.7188 64.2001C81.7188 60.8001 84.2187 57.6001 88.9187 57.6001C93.7187 57.6001 96.3187 60.7001 96.3187 63.8001C96.3187 66.3001 95.0188 68.0001 93.2188 69.3001L91.9187 70.2001C90.8187 71.0001 90.2188 72.0001 90.2188 73.2001V73.4001H86.9187ZM88.6187 75.4001C90.0187 75.4001 91.1187 76.5001 91.1187 77.9001C91.1187 79.3001 90.0187 80.4001 88.6187 80.4001C87.2187 80.4001 86.1187 79.3001 86.1187 77.9001C86.2187 76.6001 87.2187 75.4001 88.6187 75.4001Z"
      fill="#989FB0"
    />
    <path
      d="M122.399 104.423C121.533 104.423 120.668 104.077 119.975 103.298L105.52 88.8431L105 89.1893C100.326 92.6516 94.8732 94.4694 89.3334 94.4694C82.6684 94.4694 76.0033 91.7861 71.0694 87.1119C65.8759 82.178 63.0195 75.5131 63.0195 68.2421C63.0195 53.7866 74.7915 42.0146 89.2468 42.0146C99.1146 42.0146 107.77 47.2082 112.444 56.0372C117.032 64.7796 116.426 74.9937 110.8 83.2168L110.454 83.7361L124.996 98.2784C126.467 99.7494 126.121 101.221 125.861 102C125.169 103.385 123.784 104.423 122.399 104.423ZM89.2468 49.199C78.6866 49.199 70.2039 57.7684 70.2039 68.2421C70.2039 80.1871 79.985 87.3715 89.5065 87.3715C95.306 87.3715 100.586 84.7748 104.308 80.1006C108.896 74.3877 109.675 66.6839 106.472 60.0189C103.183 53.3538 96.6044 49.199 89.2468 49.199Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d_2329_16252"
        x={0}
        y={0}
        width={123.742}
        height={132.221}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2329_16252"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2329_16252"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2329_16252"
        x={33.6797}
        y={0.327637}
        width={115.043}
        height={132.945}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2329_16252"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2329_16252"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2329_16252"
        x1={61.8444}
        y1={8.9593}
        x2={61.8444}
        y2={100.171}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2329_16252"
        x1={91.178}
        y1={9.27023}
        x2={91.178}
        y2={101.231}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoReq;
